import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, ModalModule, UiComponentsModule } from '@fcom/ui-components';
import { DapiComponentsModule } from '@fcom/dapi/components/dapi-components.module';
import { PipesModule } from '@fcom/common/pipes';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { DirectiveModule } from '@fcom/common/directives';
import { MediaQueryService } from '@fcom/common/services';
import { GtmModule } from '@fcom/common/gtm';
import { FinFormsModule } from '@fcom/common/forms';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';
import { LoginModule } from '@fcom/common/login';
import { UtilsService } from '@fcom/common-booking/services/utils.service';

import { DangerousGoodsModalComponent } from './components/dangerous-goods/dangerousgoods-modal.component';
import { LocationsPipeModule } from '../locations-pipe';
import { PurchaseCheckoutComponent } from './components/purchase-checkout/purchase-checkout.component';
import { QueueService } from './services/queue.service';
import { PaymentService } from './services/payment.service';
import { PassengerReviewItemComponent } from './components/passenger-review-item/passenger-review-item.component';
import { ItineraryComponent } from './components/itinerary/itinerary.component';
import { ItineraryTimelineComponent } from './components/itinerary/itinerary-timeline.component';
import { SectionReviewComponent } from './components/section-review/section-review.component';
import { SectionReviewItemComponent } from './components/section-review/section-review-item.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StatusBarComponent } from './components/status-bar/index';
import { BookingPlainHeaderAreaComponent } from './components/booking-plain-header-area/booking-plain-header-area.component';
import { PriceBreakdownComponent } from './components/price-breakdown/price-breakdown.component';
import { EndpointTimeComponent } from './components/endpoint-time/endpoint-time.component';
import { SubHeaderComponent } from './components/sub-header/sub-header.component';
import { FlightReviewCardComponent } from './components/flight-review-card/flight-review-card.component';
import { AirBoundsFareFamilyOptionComponent } from './components/flight-selection/fare-family-option/fare-family-option.component';
import { BoundContainerComponent } from './components/flight-selection/bound-container/bound-container.component';
import { TicketSelectionSortByComponent } from './components/flight-selection/ticket-selection-sort-by/ticket-selection-sort-by.component';
import { BenefitComponent } from './components/flight-selection/benefit/benefit.component';
import { FareFamilyDetailsComponent } from './components/flight-selection/fare-family-details/fare-family-details.component';
import { FareFamilyTableComponent } from './components/flight-selection/fare-family-table/fare-family-table.component';
import { PaxDetailsFormGroupComponent } from './components/pax-details/pax-details-form-group.component';
import { ExpanderCardComponent } from './components/expander-card/expander-card.component';
import { UpsellOptionComponent } from './components/flight-selection/upsell-option/upsell-option.component';
import { ItineraryTimelineBoundHeaderComponent } from './components/itinerary/bound-header/itinerary-timeline-bound-header.component';
import { ItineraryTimelineLayoverComponent } from './components/itinerary/layover/itinerary-timeline-layover.component';
import { ItineraryTimelineLegEndpointComponent } from './components/itinerary/leg-endpoint/leg-endpoint.component';
import { ItineraryTimelineLegTechnicalStopsComponent } from './components/itinerary/leg-technical-stops/leg-technical-stops.component';
import { ItineraryTimelineFlightComponent } from './components/itinerary/flight/itinerary-timeline-flight.component';
import { GreetingCardComponent } from './components/login-promotion/greeting-card/greeting-card.component';
import { LoginPromotionComponent } from './components/login-promotion/login-promotion.component';
import { PaxFlightReviewSummaryComponent } from './components/pax-details/pax-flight-review-summary/pax-flight-review-summary.component';
import { FlightReviewCardCommonComponent } from './components/flight-review-card/flight-review-card-common/flight-review-card-common.component';
import { BoundSelectionItemComponent } from './components/bound-selection-item/bound-selection-item.component';
import { FareFamilyDetailsV2Component } from './components/flight-selection/fare-family-details-v2/fare-family-details-v2.component';
import { CountrySelectionComponent } from './components/country-selection/country-selection.component';
import { FlightCardComponent } from './components/flight-card/flight-card.component';
import { FlightSummaryComponent } from './components/flight-card/flight-summary/flight-summary.component';

const COMPONENTS = [
  PassengerReviewItemComponent,
  ItineraryComponent,
  ItineraryTimelineComponent,
  ItineraryTimelineLegEndpointComponent,
  ItineraryTimelineLegTechnicalStopsComponent,
  ItineraryTimelineBoundHeaderComponent,
  ItineraryTimelineLayoverComponent,
  ItineraryTimelineFlightComponent,
  SectionReviewComponent,
  SectionReviewItemComponent,
  SpinnerComponent,
  StatusBarComponent,
  BookingPlainHeaderAreaComponent,
  PriceBreakdownComponent,
  PurchaseCheckoutComponent,
  EndpointTimeComponent,
  SubHeaderComponent,
  FlightReviewCardComponent,
  AirBoundsFareFamilyOptionComponent,
  BoundContainerComponent,
  TicketSelectionSortByComponent,
  BenefitComponent,
  FareFamilyDetailsComponent,
  FareFamilyTableComponent,
  PaxDetailsFormGroupComponent,
  ExpanderCardComponent,
  UpsellOptionComponent,
  GreetingCardComponent,
  LoginPromotionComponent,
  FlightCardComponent,
  PaxFlightReviewSummaryComponent,
  FlightReviewCardCommonComponent,
  FlightSummaryComponent,
  BoundSelectionItemComponent,
  FareFamilyDetailsV2Component,
  CountrySelectionComponent,
  DangerousGoodsModalComponent,
];

@NgModule({
  providers: [PaymentService, QueueService, MediaQueryService, UtilsService],
  imports: [
    LocationsPipeModule,
    FormsModule,
    FinFormsModule,
    CommonModule,
    DapiComponentsModule,
    DirectiveModule,
    UiTranslateModule,
    UiComponentsModule,
    IconsModule,
    PipesModule,
    ModalModule,
    ComponentsModule,
    GtmModule,
    CommonServiceFormsModule,
    LoginModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS, DapiComponentsModule],
})
export class CommonBookingComponentsModule {}
